import React from 'react';

const PortfolioPostChallenge = () => {
    return (
        <section data-padding="top" className="backlight-top">
            <div className="stg-row stg-bottom-gap-l">
                <div className="stg-col-6 stg-tp-bottom-gap" data-appear="fade-right" data-unload="fade-left">
                    <h2>The Challenge</h2>
                </div>
                <div className="stg-col-6 stg-tp-col-10 stg-tp-offset-2" data-appear="fade-left" data-unload="fade-right">
                    <p className="infocolors-large-text">Curology was a rapidly growing digital dermatology platform with a strong focus on personalized formulas. However, their brand identity lacked coherence and struggled to connect with their target audience on a deeper level. They needed a bold, human-centric approach that reflected their innovative solutions and resonated with customers seeking effective skincare.</p>
                </div>
            </div>
            <div className="stg-row" data-appear="fade-up" data-unload="zoom-out">
                <div className="stg-col-6 stg-offset-3 stg-tp-col-8 stg-tp-offset-2">
                    <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio01/image01.jpg" alt="Curology" width="1200" height="1200" />
                </div>
            </div>
        </section>
    );
};

export default PortfolioPostChallenge;
